// CustomProductPage1.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../components/styles/CustomProductPage1.css';

const CustomProductPage1 = () => {
    const navigate = useNavigate();

    return (
        <div className="custom-product-page">
            <div className="custom-inner">
                <div className="custom-left">
                    <h2>
                        당신의 원활한 작업을 위한 <br />
                        맞춤형 소프트웨어 솔루션
                    </h2>
                    <p className="desc">소프트캣에게 맞춤 상품 신청을 해보세요</p>
                    <div className="custom-contact">
                        TEL. 010-5502-9714 <br />
                        MAIL. oracle7579@gmail.com
                    </div>
                </div>
                <div className="custom-right">
                    <button className="apply-button" onClick={() => navigate('/custom-product-second')}>
                        신청하기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomProductPage1;
